import React from 'react';
import { sortByInt } from '../../../../helpers';
import { FormHeader, FormFooter, FormBody, Form } from '../../../../modules/Form/styled';
import Buttons from '../../../../modules/Buttons';
import Button from '../../../../components/inputs/Button';

const FormAddEvent = ({ title, events, buttons, onClickEvent, onClickCancel }) => {
    const handleSubmit = e => {
        e.prventDefault();
    }
    const sortEvents = sortByInt({ direct: 'asc', key: 'order' })
    return (
        <Form onSubmit={handleSubmit}>
            <FormHeader>
                {title && title}
            </FormHeader>
            <FormBody minHeight={false}>
                <Buttons margin={8}>
                    {
                        events &&
                        sortEvents(events).map(event => (
                            <Button
                                key={event.id}
                                big
                                transparentGrey
                                type='button'
                                onClick={onClickEvent(event)}
                            >
                                {event.button}
                            </Button>
                        ))
                    }
                </Buttons>
            </FormBody>
            <FormFooter>
                <Buttons>
                    <Button
                        type='button'
                        fullWidth
                        onClick={onClickCancel}
                    >
                        {buttons && buttons.cancel}
                    </Button>
                </Buttons>
            </FormFooter>
        </Form>
    )
};

export default FormAddEvent;
